import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import PageTracker from "@/components/PageTracker";
import BackToTop from "@/components/BackToTop";
import Results from "@/pages/Results";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Media from "@/pages/Media";
import MapPage from "@/pages/MapPage";
import SchemesPage from "@/pages/SchemesPage";
import Candidates from "@/pages/Candidates";
import Messages from "@/pages/Messages";
import Analytics from "@/pages/Analytics";

function FactsRedirect() {
  const [params] = useSearchParams();
  return <Navigate to={params.get("tab") === "schemes" ? "/schemes" : "/changes"} replace />;
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<MapPage variant="leaders" />} />
          <Route path="/changes" element={<MapPage variant="changes" />} />
          <Route path="/schemes" element={<SchemesPage />} />
          <Route path="/candidates" element={<Candidates />} />
          <Route path="/c/:name" element={<Results />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/media" element={<Media />} />
          <Route path="/map" element={<Navigate to="/changes" replace />} />
          <Route path="/facts" element={<FactsRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/admin/messages" element={<Messages />} />
          <Route path="/admin/analytics" element={<Analytics />} />
        </Routes>
        <BackToTop />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
